import ajax from "./ajax";

export function getCategory() {
  return ajax(`/jobcategories?sort=-id&per-page=1000`);
}
